import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { bindActionCreators } from 'redux'
import Button from 'components/common/button'
import useAddToBag from 'components/shared/useRedux/useAddToBag'
import useAddToWaitlist from 'components/shared/useRedux/useAddToWaitlist'
import { BUTTON_TYPES } from 'constants/button'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import clsx from 'clsx'
import Typo from 'constants/typography'
import openPdpBag from '../../mobile-buying-flow/openPdpBag'
import { CTA_KEYS } from './const'
import { getCtaKey, noSizeSelectNotice, optionAction } from './utils'

const ProductAddToBagCTA = ({
  isDisabled,
  addToBagAction,
  addToWaitlistAction,
  localWaitlists,
  product,
  selectedOption,
  setLocalWaitlists,
  setOptionMessage,
  showFallback,
  t,
  setWaitlistSnackBarOpen,
  cashbackText,
  isShowEarnCashbackPDP,
  isFetched,
  selectSizeLabel,
  onSelectSize,
  openBagOnSuccess,
  openBag,
}) => {
  const [isProcessing, setIsProcessing] = useState(false)
  const ctaKey = !isProcessing
    ? getCtaKey(localWaitlists, product, selectedOption)
    : CTA_KEYS.loading

  const doneProcessing = () => setIsProcessing(false)

  const onCtaClick = () => {
    if (!selectedOption) {
      noSizeSelectNotice(ctaKey, setOptionMessage, t)
      onSelectSize?.()
      return
    }

    setIsProcessing(true)

    optionAction(
      addToBagAction,
      addToWaitlistAction,
      ctaKey,
      doneProcessing,
      localWaitlists,
      product,
      selectedOption,
      setLocalWaitlists,
      showFallback,
      setWaitlistSnackBarOpen,
      openBagOnSuccess ? openBag : undefined,
    )
  }

  return (
    <Button
      className="pdp__add-to-bag-cta"
      type={BUTTON_TYPES.primary}
      onClick={onCtaClick}
      disabled={isDisabled || isProcessing || ctaKey === CTA_KEYS.waitlisted}
    >
      {selectSizeLabel && !selectedOption && ctaKey === CTA_KEYS.addToBag
        ? selectSizeLabel
        : t(ctaKey)}
      {!!isShowEarnCashbackPDP && isFetched && (
        <span className={clsx(Typo.price2, 'pdp__cashback-text')}>
          {hasLocizeTranslation(t, cashbackText.key, cashbackText.text).replace(
            '%d',
            product.cashback.cashback_earned_formatted,
          )}
        </span>
      )}
    </Button>
  )
}

ProductAddToBagCTA.defaultProps = {
  isDisabled: false,
  cart: null,
  selectedOption: null,
  setWaitlistSnackBarOpen: null,
  cashbackText: null,
  isShowEarnCashbackPDP: false,
  isFetched: false,
  selectSizeLabel: null,
  onSelectSize: null,
  openBagOnSuccess: false,
}

ProductAddToBagCTA.propTypes = {
  selectSizeLabel: PropTypes.string,
  onSelectSize: PropTypes.func,
  openBagOnSuccess: PropTypes.bool,
  openBag: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  cart: PropTypes.shape({}),
  localWaitlists: PropTypes.shape({}).isRequired,
  product: PropTypes.shape({
    attributes: PropTypes.arrayOf(PropTypes.shape({})),
    stock: PropTypes.shape({
      quantity: PropTypes.number,
      is_sold_out: PropTypes.bool,
    }),
    cashback: PropTypes.shape({
      cashback_earned: PropTypes.number,
      cashback_earned_formatted: PropTypes.string,
    }),
  }).isRequired,
  selectedOption: PropTypes.shape({}),
  setLocalWaitlists: PropTypes.func.isRequired,
  setOptionMessage: PropTypes.func.isRequired,
  showFallback: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  addToBagAction: PropTypes.func.isRequired,
  addToWaitlistAction: PropTypes.func.isRequired,
  setWaitlistSnackBarOpen: PropTypes.func,
  cashbackText: PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
  }),
  isShowEarnCashbackPDP: PropTypes.bool,
  isFetched: PropTypes.bool,
}

export default compose(
  connect(
    () => ({}), // we can't bind action creator with dispatch without this.
    (dispatch) =>
      bindActionCreators(
        {
          addToBagAction: useAddToBag,
          addToWaitlistAction: useAddToWaitlist,
          openBag: openPdpBag,
        },
        dispatch,
      ),
  ),
  withI18next(),
)(ProductAddToBagCTA)
